// src/components/helpers/FormSelect.js
import React, { memo } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

function FormSelect({
  label,
  id,
  value,
  onChange,
  required,
  children,
  status,
  error,
  helperText,
  ...props
}) {
  const getBorderColor = () => {
    switch (status) {
      case "error":
        return "#f44336";
      case "warning":
        return "#ffd500";
      case "success":
        return "#4caf50";
      default:
        return "";
    }
  };

  return (
    <FormControl
      variant="outlined"
      fullWidth
      required={required}
      className="form-control"
      error={error}
      {...props}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: getBorderColor(),
          },
          "&:hover fieldset": {
            borderColor: getBorderColor(),
          },
          "&.Mui-focused fieldset": {
            borderColor: getBorderColor(),
          },
        },
      }}
    >
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value}
        onChange={onChange}
        label={label}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
}

export default memo(FormSelect);
